import React, { useEffect } from 'react'
import { Field } from 'redux-form'
import { connect } from 'react-redux'
import { renderSelectField } from '../../fieldRenderers'
import { obtenerMotivosActividadBarrera } from '../../../Pesado/actions'

function MotivosActividadBarrera (props) {
  const { motivosActBarrera, isRequesting, obtenerMotivosActividadBarrera } = props

  useEffect(() => {
    obtenerMotivosActividadBarrera()
  }, [obtenerMotivosActividadBarrera])

  const onSelect = (motivo) => {
    if (motivo) {
      props.setMotivo(motivo.target.value)
    }
  }

  const renderMotivos = () => {
    const option = motivosActBarrera && motivosActBarrera.map(motivo => {
      return (
        <option
          value={motivo.nombreCorto}
          key={motivo.nombreCorto}
        >
          {motivo.nombre}
        </option>
      )
    })
    option.unshift((<option value={null} key={0} />))
    return option
  }

  return (
    <Field
      onChange={onSelect}
      name='motivoActBarrera'
      label='Motivo de cambio de estado barrera'
      component={renderSelectField}
    >
      {(!isRequesting && motivosActBarrera) ? renderMotivos() : null}
    </Field>
  )
}

const mapStateToProps = (state) => ({
  isRequesting: state.motivosRechazo.isRequestingMotivosActBarrera,
  motivosActBarrera: state.pesado.motivosActividadBarrera
})

const mapActionsToProps = {
  obtenerMotivosActividadBarrera
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(MotivosActividadBarrera)
